import React from "react";
import BackToHomeLink from "../BackToHomeLink";
import Container from "../Container";
import Content from "../Content";
import { SUPPORT_EMAIL } from "../../utils/constants";

const ErrorMessage = () => (
  <Container>
    <Content>
      <h1>500: An Error Has Occurred</h1>
      <p>
        We are unable to display the page you requested. You can try reloading
        the page now or in a few minutes.
      </p>
      <p>
        If you see this message again, contact us at{" "}
        <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
      </p>
      <p>
        <BackToHomeLink />
      </p>
    </Content>
  </Container>
);

export default ErrorMessage;
